// src/app/questionare.model.ts
export interface Questionare {
  id?: number;
  questionareCategory: string;
  subCategory: string;
  questionareName: string;
  questionareDescription: string;
  questions: Question[];
}

export interface Question {
  id?: number;
  category: string;
  description: string;
  typeOfQuestion: TypeOfQuestion;
  answer: string;
}

export enum TypeOfQuestion {
  TrueFalse      = 0,
  MultipleChoice = 1,
  ShortAnswer    = 2,
  MultipleAnswer = 3
}
